import classes from './TransactionStatus.module.css';

const TRANSACTION_STATUS = {
  Paid: 'paid',
  Unpaid: 'unpaid',
};
const TRANSACTION_STATUS_COLOR = {
  [TRANSACTION_STATUS.Paid]: '#AEE9D1',
  [TRANSACTION_STATUS.Unpaid]: '#FED3D1',
};

// eslint-disable-next-line react/prop-types
export const TransactionStatus = ({ status, style = {} }) => {
  const color = TRANSACTION_STATUS_COLOR[status];
  return (
    <div className={classes.status} style={{ background: color, ...style }}>
      <span className={classes.status_text}>{status}</span>
    </div>
  );
};
